import { MessageService } from 'primeng/api';

import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { withInterceptors, provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, provideZonelessChangeDetection, provideBrowserGlobalErrorListeners } from '@angular/core';

import { routes } from './routes';

import { provideSvgSprite, provideAuthSession, provideAppTranslation } from '@/app/core/providers';
import { authInterceptor, baseUrlInterceptor, refreshInterceptor, unwrapApiEnvelopeInterceptor } from '@/app/core/http';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideAppTranslation(),
    provideSvgSprite(),
    provideHttpClient(
      withInterceptors([baseUrlInterceptor, authInterceptor, refreshInterceptor, unwrapApiEnvelopeInterceptor]),
    ),
    provideAuthSession(),
    provideAnimations(),
    MessageService,
  ],
};
